// TODO [polyfills] use core-js to polyfill this language features
if (!Blob.prototype.arrayBuffer) {
  Blob.prototype.arrayBuffer = async function arrayBufferPolyfill() {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.addEventListener('load', ({ target }) => {
        resolve(target.result);
      });
      reader.addEventListener('abort', ({ target }) => {
        reject(target.error);
      });
      reader.readAsArrayBuffer(this);
    });
  };
}
